<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="70px"
        size="mini"
      >
        <el-form-item label="时间：">
          <el-date-picker
            v-model="form.dateValue"
            type="datetimerange"
            align="right"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <div v-for="(item, index) of form.condidions" :key="item.seq">
          <el-form-item :label="`条件` + (index + 1) + `：`">
            <el-select v-model="item.condition" placeholder="请选择条件">
              <el-option
                v-for="conitionItem in avaiableConditions"
                :key="conitionItem.value + $util.uuid()"
                :hidden="isHiddenCondidtion(conitionItem.value)"
                :label="conitionItem.label"
                :value="conitionItem.value"
              ></el-option>
            </el-select>
            <span v-if="item.condition">
              {{ getCondition(item.condition).notation }}
              <el-select
                v-if="getInputTypeByCondition(item.condition) == 'select'"
                filterable
                v-model="item.value"
                placeholder="请选择值"
              >
                <el-option
                  v-for="value in getValuesByCondition(item.condition)"
                  :key="value + $util.uuid()"
                  :label="value.label"
                  :value="value.value"
                ></el-option>
              </el-select>
              <el-input
                v-else
                v-model="item.value"
                style="width: 200px"
              ></el-input>
            </span>
            <el-button
              @click="onClickRemoveConditionBtn(index)"
              style="margin-left: 10px"
              icon="el-icon-delete"
              circle
            ></el-button>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="addCondition()" class="el-icon-plus"
            >添加条件</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            style="margin-left: 10px"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 1151px; margin-top: 10px"
      height="650px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column prop="createdAt" label="时间" align="center" width="140">
        <template slot-scope="scope">
          <span>{{ ms2datetime(Number(scope.row.createdAt)) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="uniqueId"
        label="唯一标识"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <el-table-column prop="zoneId" label="分区" align="center" width="50">
      </el-table-column>
      <el-table-column prop="aid" label="AID" align="center" width="80">
      </el-table-column>
      <el-table-column prop="uid" label="UID" align="center" width="80">
      </el-table-column>
      <el-table-column
        prop="eventScene"
        label="事件"
        align="center"
        width="250"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="资产"
        align="center"
        width="250"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="amount" label="变更量" align="center" width="100">
      </el-table-column>
      <!-- <el-table-column
        prop="amountBeforeChange"
        label="变更前的量"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="amountAfterChange"
        label="变更后的量"
        align="center"
        width="100"
      >
      </el-table-column> -->
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="200"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      list: [], //
      form: {
        condidions: [],
        dateValue: [],
      },
      cacheFormForQuery: {
        condidions: [],
        dateValue: [],
      },
      avaiableConditions: [
        {
          value: "uid",
          label: "UID",
          notation: "=",
        },
        {
          value: "aid",
          label: "AID",
        },
        {
          value: "asset_id",
          label: "资产",
          notation: "=",
        },
        {
          value: "event_scene",
          label: "事件",
        },
        {
          value: "amount_consumption",
          label: "资产消耗量",
          notation: "<",
        },
        {
          value: "amount_gaven",
          label: "资产获得量",
          notation: ">",
        },
      ], // 可用的条件
      nameList: [], // 资产名称集合
      eventList: [], // 事件集合
    };
  },

  async created(e) {
    this.loadNameList();
    this.loadEventList();

    let now = new Date();
    this.form.dateValue = [
      new Date(new Date().setHours(0, 0, 0, 0)),
      new Date(new Date().setHours(0, 0, 0, 0) + 3600 * 1000 * 24),
    ];
    await this.loadList(0, 10);
  },

  components: {},

  methods: {
    getCondition(val) {
      for (let v of this.avaiableConditions) {
        if (v.value == val) {
          return v;
        }
      }
    },
    isHiddenCondidtion(val) {
      if (val == "amount_consumption" || val == "amount_gaven") {
        for (let v of this.form.condidions) {
          switch (v.condition) {
            case "amount_consumption": {
              return true;
            }
            case "amount_gaven": {
              return true;
            }
          }
        }
      }

      return false;
    },
    loadMore() {
      this.loadList(this.list.length, 10);
    },
    ms2datetime(ts) {
      return util.ms2datetime(ts);
    },
    /**
     * 查询集合
     */
    async loadList(skip, limit) {
      if (skip == 0) {
        this.cacheFormForQuery.dateValue = [
          this.form.dateValue[0],
          this.form.dateValue[1],
        ];
        this.cacheFormForQuery.condidions = JSON.parse(
          JSON.stringify(this.form.condidions)
        );
        this.list = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getLimitAssetChangesByCondition`,
          {
            skip: skip,
            limit: limit,
            startAt: this.cacheFormForQuery.dateValue[0].getTime(),
            endAt: this.cacheFormForQuery.dateValue[1].getTime(),
            conditions: this.cacheFormForQuery.condidions,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = this.list.concat(listInResponse);
    },
    addCondition() {
      this.form.condidions.push({
        condition: "",
        value: "",
      });
    },
    onClickRemoveConditionBtn(index) {
      this.form.condidions.splice(index, 1);
    },
    /**
     * 点击查询按钮
     */
    async onClickQueryBtn() {
      await this.loadList(0, 30);
    },

    /**
     * 查询资产中的name集合
     */
    async loadNameList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAssetNames`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.nameList = resData.data.names || [];
    },

    /**
     * 查询EventScene集合
     */
    async loadEventList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAssetEventScene`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.eventList = resData.data.events || [];
    },

    /**
     * 根据条件得到结果集合
     * @param {*} condition
     */
    getValuesByCondition(condition) {
      switch (condition) {
        case "asset_id": {
          return this.nameList;
        }
        case "event_scene": {
          return this.eventList;
        }
        default: {
          return null;
        }
      }
    },
    /**
     * 根据条件得到输入框类型
     * @param {*} condition
     */
    getInputTypeByCondition(condition) {
      switch (condition) {
        case "asset_id": {
        }
        case "event_scene": {
          return "select";
        }
      }
    },

    /**
     * 跳转到玩家详情界面
     * @param {*}
     */
    toRouterPlayerInfoPage(condition, value) {
      let query = {};
      switch (condition) {
        case "uid": {
          query = { uid: value, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: value, tab: "playerList" };
          break;
        }
      }

      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__row td {
  padding: 0px 0;
}
</style>